import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { LanguageCode } from '../../Models/Models';
import { languageName } from '../../Services/languageNames';
import CustomTooltip from '../Tooltips/CustomTooltip';
import { FlagImage } from './LanguagePicker';

export interface LanguageBadgeItem {
    languageShortcut: LanguageCode;
    isDefault: boolean;
}

interface LanguageBadgeListProps {
    languages: LanguageBadgeItem[];
    accentColor: string;
    tooltipIdPrefix?: string;
}

const LanguageBadgeList: React.FC<LanguageBadgeListProps> = ({ languages, accentColor, tooltipIdPrefix }) => (
    <div className="languages-print">
        {languages.map(lang => (
            <CustomTooltip
                key={lang.languageShortcut}
                placement="top"
                tooltipId={tooltipIdPrefix ? `${tooltipIdPrefix}-${lang.languageShortcut}` : undefined}
                message={
                    languageName(lang.languageShortcut) +
                    (lang.isDefault ? ' (predvolený)' : '')
                }
            >
                <span className="st-flag-badge">
                    <FlagImage code={lang.languageShortcut} size="md" />
                    {lang.isDefault && (
                        <span
                            className="st-flag-badge__star"
                            style={{ '--badge-accent': accentColor } as React.CSSProperties}
                        >
                            <FontAwesomeIcon icon={faStar} />
                        </span>
                    )}
                </span>
            </CustomTooltip>
        ))}
    </div>
);

export default LanguageBadgeList;
